import React, {useEffect, useState} from 'react'
import {Popover} from '@mui/material'
import {Text} from '../../common/text'
import styled from 'styled-components'
import {useTranslation} from 'react-i18next'
import './index.scss'
import {Tooltip} from '../../common/tooltip'
import useGlobalContext from '../../containerContext/storeContext'

export const languageList = [
   {code: 'vi', name: 'Tiếng Việt', api: 'vi,vi-VN,en,en-US,cn,cn-CN,km,km-KH'},
   {code: 'en', name: 'English', api: 'en,en-US,vi,vi-VN,cn,cn-CN,km,km-KH'},
   {code: 'cn', name: '汉语', api: 'cn,cn-CN,en,en-US,vi,vi-VN,km,km-KH'},
   {code: 'km', name: 'ខេមរភាសា', api: 'km,km-KH,vi,vi-VN,cn,cn-CN,en,en-US'},
]
export const LanguageSelect = () => {
   const [anchorEl, setAnchorEl] = useState()
   const [state, dispatch] = useGlobalContext()
   const handleOpen = e => setAnchorEl(e.currentTarget)
   const handleClose = () => setAnchorEl(null)
   const open = Boolean(anchorEl)
   const id = open ? 'simple-popover' : undefined
   const {t, i18n} = useTranslation()
   const setCloseAnchor = () => {
      setAnchorEl(null)
   }
   const langGlobal = localStorage.getItem('i18n') || 'km'
   const onChangeLanguage = (lang) => {
      i18n.changeLanguage(lang)
      localStorage.setItem('i18n', lang)
      setCloseAnchor()
      // if(window.location.pathname === PATH.HOME && window.location.pathname !== PATH.ADMIN_DASHBOAR)
      location.reload()
   }
   return (
      <LanguageStyled>
         <div className={'header-language'}>
            <div className={'header-language__title'} onClick={handleOpen}>
               <Tooltip title={t('language')}>
                  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                     <path
                        d="M16 26C14.6289 26 13.335 25.7372 12.1184 25.2115C10.9018 24.6859 9.84076 23.9703 8.93522 23.0648C8.02969 22.1592 7.31411 21.0982 6.78848 19.8816C6.26283 18.665 6 17.3711 6 16C6 14.6181 6.26283 13.3215 6.78848 12.1103C7.31411 10.8991 8.02969 9.84076 8.93522 8.93522C9.84076 8.02969 10.9018 7.31411 12.1184 6.78848C13.335 6.26283 14.6289 6 16 6C17.3819 6 18.6785 6.26283 19.8897 6.78848C21.1009 7.31411 22.1592 8.02969 23.0648 8.93522C23.9703 9.84076 24.6859 10.8991 25.2115 12.1103C25.7372 13.3215 26 14.6181 26 16C26 17.3711 25.7372 18.665 25.2115 19.8816C24.6859 21.0982 23.9703 22.1592 23.0648 23.0648C22.1592 23.9703 21.1009 24.6859 19.8897 25.2115C18.6785 25.7372 17.3819 26 16 26ZM16 24.3988C16.5371 23.6862 16.9892 22.9676 17.3563 22.2429C17.7234 21.5182 18.0223 20.726 18.2531 19.8664H13.7469C13.9912 20.753 14.2935 21.5587 14.6538 22.2834C15.0142 23.0081 15.4629 23.7132 16 24.3988ZM13.9616 24.1093C13.5581 23.5304 13.1957 22.8721 12.8745 22.1346C12.5533 21.3971 12.3037 20.641 12.1255 19.8664H8.55461C9.11063 20.9595 9.85626 21.8779 10.7915 22.6215C11.7267 23.3651 12.7834 23.861 13.9616 24.1093ZM18.0384 24.1093C19.2166 23.861 20.2733 23.3651 21.2085 22.6215C22.1437 21.8779 22.8894 20.9595 23.4454 19.8664H19.8745C19.6626 20.6478 19.3961 21.4072 19.0749 22.1448C18.7537 22.8823 18.4082 23.5371 18.0384 24.1093ZM7.89269 18.2875H11.8057C11.7395 17.8961 11.6916 17.5125 11.662 17.1367C11.6323 16.7608 11.6174 16.3819 11.6174 16C11.6174 15.6181 11.6323 15.2392 11.662 14.8633C11.6916 14.4875 11.7395 14.1039 11.8057 13.7125H7.89269C7.79148 14.0702 7.71388 14.442 7.6599 14.8279C7.60592 15.2139 7.57893 15.6046 7.57893 16C7.57893 16.3954 7.60592 16.7861 7.6599 17.1721C7.71388 17.558 7.79148 17.9298 7.89269 18.2875ZM13.3846 18.2875H18.6154C18.6815 17.8961 18.7294 17.5159 18.7591 17.1468C18.7888 16.7777 18.8037 16.3954 18.8037 16C18.8037 15.6046 18.7888 15.2223 18.7591 14.8532C18.7294 14.4841 18.6815 14.1039 18.6154 13.7125H13.3846C13.3185 14.1039 13.2706 14.4841 13.2409 14.8532C13.2112 15.2223 13.1963 15.6046 13.1963 16C13.1963 16.3954 13.2112 16.7777 13.2409 17.1468C13.2706 17.5159 13.3185 17.8961 13.3846 18.2875ZM20.1943 18.2875H24.1073C24.2085 17.9298 24.2861 17.558 24.3401 17.1721C24.3941 16.7861 24.4211 16.3954 24.4211 16C24.4211 15.6046 24.3941 15.2139 24.3401 14.8279C24.2861 14.442 24.2085 14.0702 24.1073 13.7125H20.1943C20.2604 14.1039 20.3084 14.4875 20.338 14.8633C20.3677 15.2392 20.3826 15.6181 20.3826 16C20.3826 16.3819 20.3677 16.7608 20.338 17.1367C20.3084 17.5125 20.2604 17.8961 20.1943 18.2875ZM19.8745 12.1336H23.4454C22.8826 11.027 22.142 10.1086 21.2237 9.37851C20.3053 8.64842 19.2436 8.14909 18.0384 7.88053C18.4419 8.49322 18.8009 9.16326 19.1153 9.89067C19.4298 10.6181 19.6829 11.3657 19.8745 12.1336ZM13.7469 12.1336H18.2531C18.0088 11.2537 17.7014 10.443 17.331 9.7014C16.9605 8.95984 16.5169 8.25977 16 7.60119C15.4831 8.25977 15.0395 8.95984 14.669 9.7014C14.2986 10.443 13.9912 11.2537 13.7469 12.1336ZM8.55461 12.1336H12.1255C12.3171 11.3657 12.5702 10.6181 12.8846 9.89067C13.1991 9.16326 13.5581 8.49322 13.9616 7.88053C12.7497 8.14909 11.6863 8.65011 10.7712 9.38359C9.85626 10.1171 9.11739 11.0337 8.55461 12.1336Z"
                        fill="#040711"/>
                  </svg>
               </Tooltip>
               {!state?.isLogin && <Text fontSize={14}
                                         color={'#161D25'}>{languageList.find(item => item.code === langGlobal)?.name || languageList.find(item => item.code === 'km')?.name}</Text>}
               {!state?.isLogin && <svg
                  width="12"
                  height="7"
                  viewBox="0 0 12 7"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
               >
                  <path
                     d="M6.00003 6.59416L11.0084 1.58583L9.83086 0.406662L6.00003 4.24L2.17003 0.406662L0.991699 1.585L6.00003 6.59416Z"
                     fill="#B9BBD3"
                  />
               </svg>}
            </div>
            <Popover
               id={id}
               open={open}
               anchorEl={anchorEl}
               onClose={handleClose}
               anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
               }}
               transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
               }}
               sx={{top: 18, right: -16}}
            >

               <div className={'content-language'} style={{padding: 16}}>
                  {
                     languageList.map(lg => (
                        <div className={'item-language'} data-active={langGlobal === lg.code}
                             onClick={() => onChangeLanguage(lg.code)}>{lg.name}
                        </div>
                     ))
                  }
               </div>
            </Popover>

         </div>
      </LanguageStyled>

   )
}

const LanguageStyled = styled.div`
  .header-language{
    &__title{
      cursor: pointer;
      display: flex;
      align-items: center;
      padding-right: 12px;
      padding-top: 4px;
      &-icontrans{
        margin-right: 6px;
      }
      span{
        margin-right: 8px;
      }
    }
    :hover{
      svg{
        background: rgba(255, 66, 78, 0.1);
        border-radius: 50%;
        path{
        fill: #E5101D;
        }
      }
      span{
        color: #E5101D!important;
      }
    }
  }

`
